export default {
  Assets: 'ASS',
  CostOfSales: 'COS',
  Equity: 'EQU',
  Expenses: 'EXP',
  Income: 'INC',
  Liabilities: 'LIA'
}
